import {useCallback, useEffect} from "react";
import {Box, Grid, TextField, Typography, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useRecoilState, useSetRecoilState} from "recoil";
import {useFormikContext} from "formik";
import {useLocation, useNavigate} from "react-router-dom";
import {FormAutocomplete, FormRadioGroup, FormTextField} from "../../common/form-fields";
import {
    formEditingState,
    newRegistrationState,
    openDialogState,
    RFMContractorDataValueState,
    RFMDataSearch
} from "../model/state";
import {FormValuesType, listRFMContractorType} from "../model/model";
import DialogConfirm from "./DialogConfirm";
import * as React from "react";
import {ALL_COUNTRIES_PREFIX, CountryType} from "../../data";

const ContractorManagementView = (props: any) => {
    const countriesPrefix:CountryType[] = ALL_COUNTRIES_PREFIX ;
    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);
    const navigate = useNavigate();
// Use Location
    const location = useLocation();

    const referenceProp = props.referenceProp + (props.ind !== undefined ? '[' + props.ind + ']' : '');

    // Use Formik Context
    const {values, setFieldValue, isSubmitting, submitForm, touched } = useFormikContext<FormValuesType>();

    const [isNewReg, updateLastRegState] = useRecoilState(newRegistrationState);
    const [contractorState, setContractorState] = useRecoilState(RFMContractorDataValueState);
    const [editingForm, setFormEditingState] = useRecoilState(formEditingState);
    const setContractorSearch = useSetRecoilState(RFMDataSearch);

    const [confirmDialogOpen, setConfirmDialogOpen] = useRecoilState(openDialogState);

    // Check isNewRegistration from url
    useEffect(() => {
        const id = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        id === 'new' ? updateLastRegState(1) : updateLastRegState(0);
        },
        [isNewReg])

    const [getContractor,] = useRecoilState(RFMContractorDataValueState);

    useEffect(() => {
            // getContractor
        },
        [])


    const searchValues = useCallback(async () => {
        // setSubmitting(true);
        // const errors = await validateForm();
        // if (_.isEmpty(errors)) {

    }, [submitForm])

    return (
        <>
            <DialogConfirm
                open={confirmDialogOpen}
                setOpen={setConfirmDialogOpen}
                data={values.contractorData}
            />

            {/*<Typography variant="h6">*/}
            {/*    {props.title}*/}
            {/*</Typography>*/}

                <Grid item container xs={12} columnSpacing={2} >
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.bpCode`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.bpCode')}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.naming`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.naming')}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.acgIdentificationCode`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.acgIdentificationCode')}
                                       disabled={!editingForm}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormAutocomplete
                            disabled
                            name={`${referenceProp}.serviceType`}
                            multiple={true}
                            options={[]}
                            label={t('royaltiesFeesManagement.contractorData.form.label.serviceType')}
                            getOptionLabel={(option) => option ? option : ''}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.bpCodeOfTheRepresentative`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.bpCodeOfTheRepresentative')}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.taxCode`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.taxCode')}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.representativeIdentificationCode`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.representativeIdentificationCode')}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.commercialExecutiveMail`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.commercialExecutiveMail')}
                                       disabled

                        />
                    </Grid>
                    <Grid item container md={3} xs={12} columnSpacing={2}>
                        <Grid item xs={6}>
                            <FormAutocomplete
                                disabled
                                name={`${referenceProp}.prefixCommercialExecutiveDeskPhone`}
                                label={t('royaltiesFeesManagement.contractorData.form.label.prefixCommercialExecutiveDeskPhone')}
                                options={countriesPrefix}
                                getOptionLabel={(option: any) => option?.code + " +" + option?.description}
                                isOptionEqualToValue={(option, value) => option?.code === value?.code}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option?.code} +{option?.description}
                                    </Box>
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormTextField name={`${referenceProp}.commercialExecutiveDeskPhone`}
                                           label={t('royaltiesFeesManagement.contractorData.form.label.commercialExecutiveDeskPhone')}
                                           disabled
                            />
                        </Grid>

                    </Grid>

                    <Grid item container md={3} xs={12} columnSpacing={2}>
                        <Grid item xs={6}>
                            <FormAutocomplete
                                disabled
                                name={`${referenceProp}.prefixCommercialExecutiveCellPhone`}
                                label={t('royaltiesFeesManagement.contractorData.form.label.prefixCommercialExecutiveCellPhone')}
                                options={countriesPrefix}
                                getOptionLabel={(option: any) => option?.code + " +" + option?.description}
                                isOptionEqualToValue={(option, value) => option?.code === value?.code}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option?.code} +{option?.description}
                                    </Box>
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormTextField name={`${referenceProp}.commercialExecutiveCellPhone`}
                                           label={t('royaltiesFeesManagement.contractorData.form.label.commercialExecutiveCellPhone')}
                                           disabled
                            />
                        </Grid>

                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.nameOfTheContactPerson`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.nameOfTheContactPerson')}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.emailOfTheContactPerson`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.emailOfTheContactPerson')}
                                       disabled
                        />
                    </Grid>

                    <Grid item container md={3} xs={12} columnSpacing={2}>
                        <Grid item xs={6}>
                            <FormAutocomplete
                                disabled
                                name={`${referenceProp}.prefixCellPhoneNumberOfTheContactPerson`}
                                label={t('royaltiesFeesManagement.contractorData.form.label.prefixCellPhoneNumberOfTheContactPerson')}
                                options={countriesPrefix}
                                getOptionLabel={(option: any) => option?.code + " +" + option?.description}
                                isOptionEqualToValue={(option, value) => option?.code === value?.code}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option?.code} +{option?.description}
                                    </Box>
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormTextField name={`${referenceProp}.cellPhoneNumberOfTheContactPerson`}
                                           label={t('royaltiesFeesManagement.contractorData.form.label.cellPhoneNumberOfTheContactPerson')}
                                           disabled
                            />
                        </Grid>

                    </Grid>

                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.iban`}
                                       label={t('royaltiesFeesManagement.contractorData.form.label.iban')}
                                       disabled
                        />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.icaoCode`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.icaoCode")}
                                       disabled
                        />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.iataCode`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.iataCode")}
                                       disabled
                        />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.companyName`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.companyName")}
                                       disabled
                        />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <FormAutocomplete
                            name={`${referenceProp}.type`}
                            label={t('royaltiesFeesManagement.contractorData.form.label.type')}
                            options={listRFMContractorType} // TODO: Fix error when select values from list in UI
                            getOptionLabel={(opt) => {
                                if (!opt) return '';
                                const label = opt.split('|')[1];
                                return t(`contractorMng.openRoyalityFeesManagement.form.labels.typeValues.${label}`, { defaultValue: label });
                              }}
                              
                            isOptionEqualToValue={(option, value) => option === value}
                            disabled
                        />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.notes`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.notes")}
                                       value={'note test'}
                                       disabled={!editingForm}
                        />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.currentStatus`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.currentStatus")}
                                       // defaultValue={!_.isEmpty(values.contractorData.currentStatus) ? values.contractorData.currentStatus : 'In Progress'}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormRadioGroup
                            name={`${referenceProp}.royaltiesDued`}
                            label={t("royaltiesFeesManagement.contractorData.form.label.royaltiesDued")}
                            readOnly={!editingForm}
                            radioButtons={[
                                {
                                    value: "YES",
                                    label: t("royaltiesFeesManagement.contractorData.form.label.yes")
                                },
                                {
                                    value: "NO",
                                    label: t("royaltiesFeesManagement.contractorData.form.label.no")
                                }
                            ]}
                        />
                    </Grid>

                    {/*<Grid item xs={6}/>*/}

                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.vatNumber`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.vatNumber")}
                                       disabled
                        />
                    </Grid>

                    {/*<Grid item md={3} xs={12}>*/}
                    {/*    <FormTextField name={`${referenceProp}.fiscalCode`}*/}
                    {/*                   label={t("royaltiesFeesManagement.contractorData.form.label.fiscalCode")}*/}
                    {/*                   disabled={!editingForm}*/}
                    {/*    />*/}
                    {/*</Grid>*/}
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.legalAddress`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.legalAddress")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.legalStreetNumber`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.legalStreetNumber")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.postalCode`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.postalCode")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.area`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.area")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.areaManager`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.areaManager")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.region`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.region")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.province`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.province")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.city`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.city")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.fax`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.fax")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.pec`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.pec")}
                                       disabled
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FormTextField name={`${referenceProp}.commercialExecutiveName`}
                                       label={t("royaltiesFeesManagement.contractorData.form.label.commercialExecutiveName")}
                                       disabled
                        />
                    </Grid>
                </Grid>


        </>
    );
}

export default ContractorManagementView